import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import Vuelidate from 'vuelidate';
import FullCalendar from 'vue-full-calendar';
import VModal from 'vue-js-modal';
import axios from 'axios';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(FullCalendar);
Vue.use(VModal, { dialog: true });

sync(store, router);


axios.interceptors.request.use((config) => {
  const { token } = store.state.auth;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, err => Promise.reject(err));

axios.interceptors.response.use(res => res, (err) => {
  /* eslint-disable no-underscore-dangle no-console */
  if (!err.response) {
    const msg = 'Could not connect to server. Make sure you are connected to the internet';
    return Promise.reject(new Error(msg));
  }
  const originalRequest = err.response.config;
  if (err.response.status === 401 &&
    !originalRequest.PG_isRetryRequest &&
    originalRequest.url !== '/api/login' &&
    originalRequest.url !== '/api/token/jwt') {
    return store.dispatch('getToken')
      .then(() => {
        originalRequest.PG_isRetryRequest = true;
        const { token } = store.state.auth;
        if (originalRequest.headers.Authorization &&
            originalRequest.headers.Authorization.indexOf('Bearer') > -1) {
          originalRequest.headers.Authorization = `Bearer ${token}`;
        }
        return Promise.resolve(axios(originalRequest));
      })
      .catch((tokenErr) => {
        originalRequest.PG_isRetryRequest = true;
        return Promise.reject(tokenErr);
      });
  }
  return Promise.reject(err);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  functional: true,
  router,
  store,
  render(h) {
    return h(App);
  },
});



// WEBPACK FOOTER //
// ./src/main.js